import {AccessService} from '../../utils/AccessService';

export const REDIRECT_CONNECT = 'connect';
export const REDIRECT_REPORTS = 'reports';
export const REDIRECT_CONNECTIONS = 'connections';
export const REDIRECT_MEMORY = 'memory';

/**
 * A dónde manda la home del portal a un cliente que NO tiene Tablero, en orden de preferencia:
 * Connect (MCP) → Informes → Memoria → Conexiones (los cinco ítems del nav del portal). Con
 * Tablero (MARKETING) se queda en la home.
 *
 * Los informes del portal son el módulo `REPORTS` (el mismo que gatea su ítem del nav en
 * `LayoutPortal`), no `INSIGHTS` — hasta 2026-09-05 esta decisión miraba INSIGHTS, así que un
 * cliente con sólo informes caía a Conexiones en vez de a sus informes. Pura, sin React: acá
 * viven los tests.
 */
export function portalHomeRedirectTarget(modules) {
    if (!modules) return null;
    const has = (m) => modules.includes(m);
    if (has(AccessService.MODULE_MARKETING)) return null;
    if (has(AccessService.MODULE_DASHBO_MCP)) return REDIRECT_CONNECT;
    if (has(AccessService.MODULE_REPORTS)) return REDIRECT_REPORTS;
    if (has(AccessService.MODULE_CLIENT_MEMORY)) return REDIRECT_MEMORY;
    if (has(AccessService.MODULE_CLIENT_CONNECTIONS)) return REDIRECT_CONNECTIONS;
    return null;
}
